module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAv0lEQVQ4T92TMQrCQBBF38drWHgR0cJC0NLGG8TaC3gBa7VW8AT2Nt7CMuAlhC8TgphgSIxWbrGws/vf7J/dEaVhexkhSevXraq4bE+ALdAtw2rWKZAE4AbMJZ1D0PQGtofAPgCWpA+zZ8czbUzAqg0gdL8BfG0hALZ7QAcYAamkU52tZw1yQAiPwB3o56BNBSSRtCsA8qqOgauka132wiv8iYUmnt80XvYToxdmki6fQGwPgEMApkA8V5tuXDwAD6ygNlJnxzcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/zhsxActive.png
// module id = h8M+
// module chunks = 96